import { httpsCallable, type HttpsCallable } from 'firebase/functions';
import { z } from 'zod';

import { SchemaValidationFailedError } from '@kilat/shared';

import { functions } from '../firebase.js';

/** Typed wrapper around the `setReviewHidden` moderation Cloud Function. */

export const SetReviewHiddenInputSchema = z.object({
  tenantId: z.string().min(1),
  outletId: z.string().min(1),
  reviewId: z.string().min(1),
  hidden: z.boolean(),
});
export type SetReviewHiddenInput = z.infer<typeof SetReviewHiddenInputSchema>;

export const SetReviewHiddenOutputSchema = z.object({
  ok: z.boolean(),
  reviewId: z.string(),
  hidden: z.boolean(),
});
export type SetReviewHiddenOutput = z.infer<typeof SetReviewHiddenOutputSchema>;

const setReviewHiddenFn: HttpsCallable<SetReviewHiddenInput, SetReviewHiddenOutput> = httpsCallable(
  functions,
  'setReviewHidden',
);

export async function callSetReviewHidden(
  input: SetReviewHiddenInput,
): Promise<SetReviewHiddenOutput> {
  const parsed = SetReviewHiddenInputSchema.safeParse(input);
  if (!parsed.success) {
    throw new SchemaValidationFailedError('setReviewHidden.input', parsed.error.flatten());
  }
  const result = await setReviewHiddenFn(parsed.data);
  const out = SetReviewHiddenOutputSchema.safeParse(result.data);
  if (!out.success) {
    throw new SchemaValidationFailedError('setReviewHidden.output', out.error.flatten());
  }
  return out.data;
}
